import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { pagingCountry, getCountryById, getAllCountry, saveCountry, deleteCountry } from 'app/services/CountryService';
import { Country } from "app/common/Model/Country";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

export default class CountryStore {
    listAllCountry = [];
    searchCountry = new SearchObject();
    pageCountry = null;
    selectedCountry = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteCountry = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllCountry = () => {
        if (this.listAllCountry?.length === 0) {
            getAllCountry()
                .then(({ data }) => this.listAllCountry = data)
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                });
        }
    }

    pagingCountry = () => {
        pagingCountry(this.searchCountry)
            .then(({ data }) => {
                this.pageCountry = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchCountry) => {
        this.searchCountry = checkSearchObject(this.searchCountry, searchCountry);
        this.pagingCountry();
    }

    handleOpenFormCreateOrEdit = (countryId) => {
        if (Boolean(countryId)) {
            getCountryById(countryId)
                .then(({ data }) => {
                    this.selectedCountry = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedCountry = new Country();
            this.openFormCreateOrEdit = true;
        }
    }

    saveCountry = (country, { setSubmitting }) => {
        return saveCountry(country).then(() => {
            this.selectedCountry = null;
            toast.success("Lưu quốc gia thành công!");
            this.handleClosePopup();
            this.pagingCountry();
        })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin quốc gia có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeleteCountry = (country) => {
        this.selectedCountry = { id: country?.id };
        this.openConfirmDeleteCountry = true;
    }

    handleConfirmDeleteCountry = () => deleteCountry(this?.selectedCountry?.id)
        .then(() => {
            if (this.searchCountry.pageIndex > 1 && this.pageCountry.content.length === 1) {
                this.searchCountry.pageIndex -= 1;
            }
            toast.success("Xóa quốc gia thành công!")
            this.handleClosePopup();
            this.pagingCountry();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa quốc gia có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteCountry = false;
    }

    resetStore = () => {
        this.searchCountry = new SearchObject();
        this.pageCountry = null;
        this.selectedCountry = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteCountry = false;
    }
}